document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

const initHwdTheme = () => {
  if (window.lucide) {
    window.lucide.createIcons({
      attrs: {
        'stroke-width': 1.5,
      },
    });
  }

};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHwdTheme);
} else {
  initHwdTheme();
}

document.addEventListener('click', (event) => {
  const menuToggle = event.target.closest('[data-hwd-menu-toggle]');
  if (menuToggle) {
    const menu = document.querySelector('[data-hwd-mobile-menu]');
    const isOpen = menu && !menu.hasAttribute('hidden');
    if (menu) {
      menu.toggleAttribute('hidden', isOpen);
      menuToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    }
  }

  const cartLink = event.target.closest('a[href="/cart"]');
  if (cartLink && window.matchMedia('(min-width: 768px)').matches) {
    const drawer = document.querySelector('[data-hwd-cart-drawer]');
    const overlay = document.querySelector('[data-hwd-cart-overlay]');
    if (drawer && overlay) {
      event.preventDefault();
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      overlay.removeAttribute('hidden');
    }
  }

  const cartClose = event.target.closest('[data-hwd-cart-close], [data-hwd-cart-overlay]');
  if (cartClose) {
    const drawer = document.querySelector('[data-hwd-cart-drawer]');
    const overlay = document.querySelector('[data-hwd-cart-overlay]');
    drawer?.classList.remove('is-open');
    drawer?.setAttribute('aria-hidden', 'true');
    overlay?.setAttribute('hidden', '');
  }

  const plus = event.target.closest('[data-hwd-qty-plus]');
  const minus = event.target.closest('[data-hwd-qty-minus]');
  if (plus || minus) {
    const control = event.target.closest('[data-hwd-qty]');
    const value = control?.querySelector('[data-hwd-qty-value]');
    if (!value) return;
    const next = Number(value.textContent) + (plus ? 1 : -1);
    const clean = Math.max(1, Math.min(10, next));
    value.textContent = clean;
    const form = control.closest('form');
    const input = form?.querySelector('[data-hwd-quantity-input]');
    if (input) input.value = clean;
  }

  const choice = event.target.closest('[data-hwd-choice]');
  if (choice) {
    const group = choice.closest('[role="group"]');
    group?.querySelectorAll('[data-hwd-choice]').forEach((item) => {
      item.setAttribute('aria-pressed', item === choice ? 'true' : 'false');
    });
  }

  const productChoice = event.target.closest('[data-hwd-product-choice]');
  if (productChoice) {
    const form = productChoice.closest('[data-hwd-product-form]');
    const variantInput = form?.querySelector('[data-hwd-variant-id]');
    const price = document.querySelector('[data-hwd-product-price]');
    const cta = form?.querySelector('[data-hwd-atc]');
    const choiceName = document.querySelector('[data-hwd-choice-name]');
    productChoice.closest('[role="group"]')?.querySelectorAll('[data-hwd-product-choice]').forEach((item) => {
      item.setAttribute('aria-pressed', item === productChoice ? 'true' : 'false');
    });
    if (variantInput) variantInput.value = productChoice.dataset.variantId;
    if (price) price.textContent = productChoice.dataset.price;
    if (cta) cta.textContent = `Add to cart · ${productChoice.dataset.price}`;
    if (choiceName) choiceName.textContent = productChoice.dataset.choiceName;
  }

  const sizeChoice = event.target.closest('[data-hwd-size-choice]');
  if (sizeChoice && !sizeChoice.disabled) {
    const scope = sizeChoice.closest('.hwd-bundle-choice') || sizeChoice.closest('[data-hwd-product-form]');
    const sizeInput = scope?.querySelector('[data-hwd-size-property]');
    sizeChoice.closest('[role="group"]')?.querySelectorAll('[data-hwd-size-choice]').forEach((item) => {
      item.setAttribute('aria-pressed', item === sizeChoice ? 'true' : 'false');
    });
    if (sizeInput) sizeInput.value = sizeChoice.value;
  }

  const braceletChoice = event.target.closest('.hwd-bracelet-tile[data-hwd-choice]');
  if (braceletChoice) {
    const scope = braceletChoice.closest('.hwd-bundle-choice');
    const input = scope?.querySelector('[data-hwd-bracelet-property]');
    if (input) input.value = braceletChoice.textContent.trim();
    const summary = scope?.querySelector('summary .small');
    if (summary) summary.textContent = braceletChoice.textContent.trim();
  }

  const bundleSizeChoice = event.target.closest('[data-hwd-size-choice]');
  if (bundleSizeChoice && bundleSizeChoice.closest('.hwd-bundle-choice')) {
    const scope = bundleSizeChoice.closest('.hwd-bundle-choice');
    const summary = scope?.querySelector('summary .small');
    if (summary) summary.textContent = `${bundleSizeChoice.value} selected`;
  }

  const thumb = event.target.closest('[data-hwd-thumb]');
  if (thumb) {
    const main = document.querySelector('[data-hwd-product-main] img');
    if (main) main.src = thumb.dataset.hwdThumb;
  }
});

document.addEventListener('toggle', (event) => {
  const details = event.target;
  if (!details.matches('[data-hwd-faq] details') || !details.open) return;
  details.parentElement.querySelectorAll('details').forEach((item) => {
    if (item !== details) item.removeAttribute('open');
  });
}, true);

window.addEventListener('scroll', () => {
  const header = document.querySelector('[data-hwd-header]');
  if (!header) return;
  header.classList.toggle('is-scrolled', window.scrollY > 120);
}, { passive: true });

document.addEventListener('submit', async (event) => {
  const bundleForm = event.target.closest('[data-hwd-bundle-form]');
  if (!bundleForm) return;

  const map = bundleForm.parentElement?.querySelector('[data-hwd-bundle-map]');
  if (!map) return;

  event.preventDefault();
  const button = bundleForm.querySelector('button[type="submit"]');
  const originalLabel = button?.textContent;
  if (button) {
    button.disabled = true;
    button.textContent = 'Adding bundle';
  }

  const bundleLabel = bundleForm.dataset.bundleLabel || 'HWD';
  const bundleHandle = bundleForm.dataset.bundleHandle || '';
  const bundlePrice = bundleForm.dataset.bundlePrice || '';
  const selections = {
    bracelet: bundleForm.querySelector('[data-hwd-bundle-choice-value="bracelet"]')?.value || 'Bone band, gold cross',
    hoodie: bundleForm.querySelector('[data-hwd-bundle-choice-value="hoodie"]')?.value || 'M',
    tshirt: bundleForm.querySelector('[data-hwd-bundle-choice-value="tshirt"]')?.value || 'M',
  };

  const findVariant = (productKey, choice) => {
    return map.querySelector(`[data-hwd-bundle-variant][data-product="${productKey}"][data-choice="${CSS.escape(choice)}"]`)?.dataset.variantId;
  };

  const items = Array.from(map.querySelectorAll('[data-hwd-bundle-item]')).map((itemNode) => {
    let id = itemNode.dataset.variantId;
    const productKey = itemNode.dataset.product;
    if (itemNode.dataset.kind === 'bracelet') id = findVariant(productKey, selections.bracelet);
    if (itemNode.dataset.kind === 'size') id = findVariant(productKey, selections[productKey]);
    if (!id) return null;
    return {
      id: Number(id),
      quantity: 1,
      properties: {
        _bundle_label: bundleLabel,
        _bundle_handle: bundleHandle,
        _bundle_price: bundlePrice,
      },
    };
  }).filter(Boolean);

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ items }),
    });
    if (!response.ok) throw new Error('Bundle add failed');
    window.location.href = '/cart';
  } catch (error) {
    console.error(error);
    if (button) {
      button.disabled = false;
      button.textContent = originalLabel || 'Add bundle';
    }
    alert('Something went wrong adding that. Try again, or refresh the page.');
  }
});
